import * as React from 'react';
import { Glyphicon } from 'react-bootstrap';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';

import { inject, bind } from '../../utils/decorators';
import { ToastStore, IToast } from '../../stores/ToastStore';

interface IToastProps {
  toast: IToast;
  onDismiss: (toast: IToast) => void;
}

@observer
class Toast extends React.Component<IToastProps, {}> {
  @observable detailsShown = false;

  componentDidMount() {
    const { toast, onDismiss } = this.props;
    setTimeout(() => onDismiss(toast), 5000);
  }

  @bind @action handleDetailsShown() {
    this.detailsShown = true;
  }

  @bind handleDismiss(event: React.SyntheticEvent<HTMLAnchorElement>) {
    event.preventDefault();
    const { toast, onDismiss } = this.props;
    if (onDismiss) {
      onDismiss(toast);
    }
  }


  render() {
    let {kind, message, details} = this.props.toast;

    let icon = undefined;
    switch (kind) {
      case 'success':
        icon = <Glyphicon glyph="ok" />;
        break;
      case 'error':
        icon = <Glyphicon glyph="exclamation-sign" />;
        message = 'Ein Fehler ist aufgetreten.';
        break;
      case 'info':
        icon = <Glyphicon glyph="info-sign" />;
        break;
      case 'warning':
        icon = <Glyphicon glyph="warning-sign" />;
        break;
      default:
        throw new Error('Unknown Notification kind');
    }

    let detailLink = undefined;
    if (details) {
      detailLink = (
        <a className="toast-more-btn" onClick={this.handleDetailsShown}>
          <Glyphicon glyph="triangle-bottom" />
        </a>
      );
    } else {
      this.handleDetailsShown();
    }

    return (
      <div className={`toast toast-${kind}`}>
        {icon && <div className="toast-icon">{icon}</div>}
        <div className="toast-message">
          {message}
          {this.detailsShown && <div>{details}</div>}
        </div>
        <div className="toast-buttons">
          <a className="toast-btn" onClick={this.handleDismiss}>
            <Glyphicon glyph="remove" />
          </a>
          {!this.detailsShown && (
            <a className="toast-btn" onClick={this.handleDetailsShown}>
              <Glyphicon glyph="triangle-bottom" />
            </a>
          )}
        </div>
      </div>
    );
  }
}

@observer
export default class ToastContainer extends React.Component<{}, {}> {

  @inject(ToastStore) toastStore: ToastStore;

  @bind handleAlertDismiss(toast: IToast) {
    this.toastStore.hide(toast);
  }

  render() {
    if (this.toastStore.notifications.length > 0) {
      return (
        <div className="toast-container">
          {this.toastStore.notifications.map((toast, index) => {
            return <Toast key={index}  toast={toast} onDismiss={this.handleAlertDismiss}/>;
          })}
        </div>
      );
    }
    return null;
  }
}




// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/ToastContainer.tsx